import React from 'react';
import { OTR_STATUS_CONFIG } from '../constants/otrStatusConfig';

export const OTRStatusBadge = ({ status }) => {
  const config = OTR_STATUS_CONFIG[status] || {
    label: status,
    bg: 'var(--status-archived-bg)',
    fg: 'var(--status-archived-fg)',
    dot: 'var(--status-archived-dot)',
  };

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold tracking-wide uppercase"
      style={{ backgroundColor: config.bg, color: config.fg }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: config.dot }}
      />
      {config.label}
    </div>
  );
};
